// Path: src/components/UpdateBanner.tsx

import { useAppVersion } from "./Useappversion";

export default function UpdateBanner() {
  const { updateAvailable, formattedTime, dismiss, refresh } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg">
      <div className="max-w-4xl mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <span>✨</span>
          <span>
            A new version is available
            {formattedTime && (
              <span className="opacity-75 font-normal ml-1">
                — deployed at {formattedTime}
              </span>
            )}
          </span>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={refresh}
            className="bg-white text-blue-600 px-3 py-1 rounded-full text-xs font-bold hover:bg-blue-50 transition-all active:scale-95"
          >
            Update Now
          </button>
          <button
            onClick={dismiss}
            className="text-white/70 hover:text-white text-xs font-medium flex items-center gap-1 transition-colors"
          >
            Later ✕
          </button>
        </div>
      </div>
    </div>
  );
}